export default __webpack_public_path__ + "static/media/Time For A Little Test.7be52cd3.png";